import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchJournal } from "../lib/api";

export default function Journal() {
    const [entries, setEntries] = useState([]);

    useEffect(() => {
        fetchJournal().then(setEntries).catch(() => {});
    }, []);

    return (
        <div data-testid="journal-page" className="pt-28">
            <section className="container-rail pb-12 border-b border-white/5">
                <div className="text-overline text-[#A3A3A3] mb-4">N° 05 · Journal · Notes from the studio</div>
                <h1 className="text-display text-5xl sm:text-6xl md:text-8xl leading-[0.9]">
                    The <span className="text-display-italic">journal</span>.
                </h1>
                <p className="text-[#A3A3A3] mt-6 max-w-xl leading-relaxed">
                    Letters on craft, material, photography, and the people behind the seams.
                </p>
            </section>

            <section className="container-rail py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16">
                    {entries.map((e, idx) => (
                        <Link
                            key={e.slug}
                            to={`/journal/${e.slug}`}
                            data-testid={`journal-card-${e.slug}`}
                            className={`group block ${idx === 0 ? "md:col-span-2" : ""}`}
                        >
                            <div className={`relative overflow-hidden bg-[#141414] border border-white/[0.06] group-hover:border-white/20 transition-colors ${idx === 0 ? "aspect-[16/8]" : "aspect-[4/5]"}`}>
                                <img
                                    src={e.cover}
                                    alt={e.title}
                                    className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-[1.03]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent" />
                                <div className="absolute bottom-5 left-5 right-5">
                                    <div className="text-overline text-white/80 mb-2">{e.chapter}</div>
                                    <h2 className={`text-display text-white leading-[1] ${idx === 0 ? "text-4xl sm:text-5xl md:text-6xl" : "text-3xl sm:text-4xl"}`}>
                                        {e.title}
                                    </h2>
                                </div>
                            </div>
                            <div className="mt-4 flex items-start justify-between gap-4">
                                <p className="text-[#A3A3A3] text-sm leading-relaxed max-w-xl">{e.excerpt}</p>
                                <div className="text-overline text-[#666] shrink-0">{e.date}</div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
